"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _operators = require("rxjs/operators");

var _reduxObservable = require("redux-observable");

var _js = require("@agile-actors/actions/dist/js");

var _epics = require("../../dist/commons/epics");

var _operators2 = require("./operators");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var emitEpic = function emitEpic(action$, state$) {
  return action$.pipe((0, _reduxObservable.ofType)(_js.emit.type), (0, _operators.map)(function (emitAction) {
    var action = emitAction.payload;
    return _objectSpread(_objectSpread({}, action), {}, {
      token: state$.value.user.token
    });
  }), (0, _operators2.emitActionToServer)());
};

var epic = (0, _reduxObservable.combineEpics)(emitEpic, _epics.requestEpic);
var _default = epic;
exports["default"] = _default;